import { AxiosRequestConfig } from "axios";
import * as _ from 'lodash'
import StorageHelper from "./StorageHelper";
export default class AxiosDefaultRequestConfig {
    static merge(data: AxiosRequestConfig): AxiosRequestConfig {
        const headersToMerge: any = {}
        const loginToken = StorageHelper.getItem('logintoken')
        if(loginToken) {
            headersToMerge.logintoken = loginToken
        }
        const config = _.merge({
            headers: headersToMerge,
            withCredentials: true
        }, data)
        return config
    }
}